import annaDsbUpi from '../../../infrastructure/constants/functions/annaDsbUpi';
import annaDsbUpiEnrichment from '../../../infrastructure/constants/functions/annaDsbUpiEnrichment';
import exchangeRates from '../../../infrastructure/constants/functions/exchangeRates';
import firdsFcaInstrument from '../../../infrastructure/constants/functions/firdsFcaInstrument';
import firdsEsmaInstrument from '../../../infrastructure/constants/functions/firdsEsmaInstrument';
import isin from '../../../infrastructure/constants/functions/isin';
import lei from '../../../infrastructure/constants/functions/lei';
import lse from '../../../infrastructure/constants/functions/lse';
import { endpointFilterType } from '../../../infrastructure/constants/report/endpointFilterType';
import ButtonContext from '../../../infrastructure/helpers/common/ButtonContext';
import aggregationHelper from '../../../infrastructure/helpers/functions/aggregation/aggregationHelper';
import reportFieldHelper from '../../../infrastructure/helpers/functions/common/reportFieldHelper';
import selectorHelper from '../../../infrastructure/helpers/functions/selectors/SelectorHelper';
import accuracyValidationValidator from '../../../infrastructure/helpers/functions/validator/accuracyValidationValidator';
import aggregationValidator from '../../../infrastructure/helpers/functions/validator/aggregationValidator';
import caseValidator from '../../../infrastructure/helpers/functions/validator/caseValidator';
import dictionaryValidator from '../../../infrastructure/helpers/functions/validator/dictionaryValidator';
import endpointFilterValidator from '../../../infrastructure/helpers/functions/validator/endpointFilterValidator';
import enrichmentValidator from '../../../infrastructure/helpers/functions/validator/enrichmentValidator';
import filterValidator from '../../../infrastructure/helpers/functions/validator/filterValidator';
import lookupValidator from '../../../infrastructure/helpers/functions/validator/lookupValidator';
import matchingKeyValidator from '../../../infrastructure/helpers/functions/validator/matchingKeyValidator';
import selectorValidator from '../../../infrastructure/helpers/functions/validator/selectorValidator';
import userDefinedFunctionValidator from '../../../infrastructure/helpers/functions/validator/userDefinedFunctionValidator';
import variableValidator from '../../../infrastructure/helpers/functions/validator/variableValidator';
import reportConfigNavigation from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import { htmlIds } from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation.HtmlIds';
import ReportCollections from '../../../infrastructure/types/Functions/ReportCollections';
import Aggregation from '../../../types/report/Aggregation';
import ReportConfig from '../../../types/report/ReportConfig';
import Selector from '../../../types/report/Selector';
import EndpointFilter from '../../../types/report/EndpointFilter';
import accuracyValidationKind from '../../../infrastructure/constants/accuracyValidationKind';
import { reportType } from '../../../infrastructure/constants/reportType';
import dataSourceValidators from '../DataSources/DataSourceForm.Validation';
import store from '../../../store/store';
import actions from '../../../store/actions';
import ComponentType from '../../../types/report/ComponentType';

const validate = async (config: ReportConfig, collections: ReportCollections): Promise<ButtonContext[]> => {

    let errors: ButtonContext[] = [];

    let dataSourceError = dataSourceValidators.validateDataSources(config);
    if (dataSourceError) {
        errors.push({ content: dataSourceError, onClick: () => reportConfigNavigation.navigateToSection(htmlIds.dataSources) });
    }

    let error = await userDefinedFunctionValidator.validateFunctions(config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.type);
    if (error.message) {

        let htmlId = reportConfigNavigation.buildFunctionId(error.mainConmponentNumber as number);

        let number = error.mainConmponentNumber;

        errors.push({
            content: error.message, onClick: () => {

                store.dispatch({
                    type: actions.navigation.navigatoToComponentNumber, payload: {
                        number,
                        htmlId,
                        sectionId: htmlIds.userDefinedFunctions,
                        componentType: ComponentType.UserDefinedFunction
                    }
                });
            }
        });
    }

    error = userDefinedFunctionValidator.validateFunctionParameters(config.userDefinedFunctions);
    if (error.message) {

        let functionNumber = error.mainConmponentNumber;

        let number = error.componentNumber;

        let htmlId = reportConfigNavigation.buildFunctionParameterId(number as number);

        errors.push({
            content: error.message,
            onClick: () => {

                store.dispatch({
                    type: actions.navigation.navigatoToComponentNumber, payload: {
                        number: functionNumber,
                        htmlId,
                        sectionId: htmlIds.userDefinedFunctions,
                        componentType: ComponentType.UserDefinedFunction
                    }
                });
            }
        });
    }

    error = variableValidator.validate(config.variables, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, collections.customDataSourceFields, config.type);
    if (error.message) {
        let htmlId = reportConfigNavigation.buildVariableId(error.componentNumber as number);

        errors.push({ content: error.message as string, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.variables) });
    }

    error = lookupValidator.validate(config.lookups, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.dictionaries, collections.dataSources, collections.reportFields, collections.customDataSourceFields, config.type);
    if (error.message) {
        let htmlId = reportConfigNavigation.buildLookupId(error.componentNumber as number);

        errors.push({ content: error.message, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.lookups) });
    }

    if (config.type !== reportType.globalModule) {

        let aggregationNumbers = aggregationValidator.validate(config, collections.dataSources, collections.globalModuleConfig.userDefinedFunctions);
        if (aggregationNumbers.length > 0) {

            aggregationNumbers.forEach(number => {

                let aggr = config.aggregations.find(a => a.number === number) as Aggregation;

                let errorField = aggr.errors.length === 0 ? aggr.fields.find(f => f.errors.length > 0) : null;

                let name = aggr.errors.length > 0 ? `aggregation ${aggregationHelper.fallbackName(aggr)}` : `aggregation field ${errorField?.fieldId}`;

                let htmlId = aggr.errors.length > 0 ? reportConfigNavigation.buildAggregationId(aggr.number) : reportConfigNavigation.buildAggregatedRecordFieldId(errorField?.fieldId as number);

                errors.push({
                    content: `Invalid '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: aggr.number,
                                htmlId,
                                sectionId: htmlIds.aggregations,
                                componentType: ComponentType.Aggregation
                            }
                        });
                    }
                });
            });
        }

        let isinSelectorsNumbers = selectorValidator.validate(config.isinSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'ISIN', 'name', isin.type, config.type);
        if (isinSelectorsNumbers.length > 0) {

            isinSelectorsNumbers.forEach(number => {

                let selector = config.isinSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'ISIN');

                let htmlId = reportConfigNavigation.buildIsinSelectorId(selector.number);

                errors.push({
                    content: `Invalid ISIN '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                componentType: ComponentType.IsinSelector,
                                number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys
                            }
                        });
                    }
                });
            });
        }

        let leiSelectorsNumbers = selectorValidator.validate(config.leiSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'LEI', 'name', lei.type, config.type);
        if (leiSelectorsNumbers.length > 0) {

            leiSelectorsNumbers.forEach(number => {

                let selector = config.leiSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'LEI');

                let htmlId = reportConfigNavigation.buildLeiSelectorId(selector.number);

                errors.push({
                    content: `Invalid LEI '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                componentType: ComponentType.LeiSelector,
                                number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys
                            }
                        });
                    }
                });
            });
        }

        let exchangeRatesSelectorsNumbers = selectorValidator.validate(config.exchangeRatesSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'ExchangeRates', 'name', exchangeRates.type, config.type);
        if (exchangeRatesSelectorsNumbers.length > 0) {

            exchangeRatesSelectorsNumbers.forEach(number => {

                let selector = config.exchangeRatesSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'ExchangeRates');

                let htmlId = reportConfigNavigation.buildExchangeRatesSelectorId(selector.number);

                errors.push({
                    content: `Invalid Exchange Rates '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                componentType: ComponentType.ExchangeRatesSelector,
                                number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys
                            }
                        });
                    }
                });
            });
        }

        let firdsFcaInstrumentSelectorsNumbers = selectorValidator.validate(config.firdsFcaInstrumentSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'FirdsInstrument', 'name', firdsFcaInstrument.type, config.type);

        if (firdsFcaInstrumentSelectorsNumbers.length > 0) {

            firdsFcaInstrumentSelectorsNumbers.forEach(number => {

                let selector = config.firdsFcaInstrumentSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'FirdsFcaInstrument');

                let htmlId = reportConfigNavigation.buildFirdsFcaInstrumentSelectorId(selector.number);

                errors.push({
                    content: `Invalid Firds FcaInstrument '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.FirdsFcaInstrumentSelectors
                            }
                        });
                    }
                });
            });
        }

        let firdsEsmaInstrumentSelectorsNumbers = selectorValidator.validate(config.firdsEsmaInstrumentSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'FirdsInstrument', 'name', firdsEsmaInstrument.type, config.type);

        if (firdsEsmaInstrumentSelectorsNumbers.length > 0) {

            firdsEsmaInstrumentSelectorsNumbers.forEach(number => {

                let selector = config.firdsEsmaInstrumentSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'FirdsEsmaInstrument');

                let htmlId = reportConfigNavigation.buildFirdsEsmaInstrumentSelectorId(selector.number);

                errors.push({
                    content: `Invalid Firds Esma Instrument '${name}'`, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.FirdsEsmaInstrumentSelectors
                            }
                        });
                    }
                });
            });
        }

        let annaDsbUpiEnrichmentSelectorsNumbers = selectorValidator.validate(config.annaDsbUpiEnrichmentSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'AnnaDsbUpiEnrichment', 'name', annaDsbUpiEnrichment.type, config.type);

        if (annaDsbUpiEnrichmentSelectorsNumbers.length > 0) {

            annaDsbUpiEnrichmentSelectorsNumbers.forEach(number => {

                let selector = config.annaDsbUpiEnrichmentSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'AnnaDsbUpiEnrichment');

                errors.push({
                    content: `Invalid Anna Dsb Upi Enrichment '${name}'`, onClick: () => {

                        let htmlId = reportConfigNavigation.buildAnnaDsbUpiEnrichmentSelectorId(selector.number);

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.AnnaDsbUpiEnrichmentSelector
                            }
                        });
                    }
                });
            });
        }

        let annaDsbUpiSelectorsNumbers = selectorValidator.validate(config.annaDsbUpiSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'AnnaDsbUpi', 'name', annaDsbUpi.type, config.type);
        if (annaDsbUpiSelectorsNumbers.length > 0) {

            annaDsbUpiSelectorsNumbers.forEach(number => {

                let selector = config.annaDsbUpiSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'AnnaDsbUpi');

                errors.push({
                    content: `Invalid Anna Dsb Upi '${name}'`, onClick: () => {

                        let htmlId = reportConfigNavigation.buildAnnaDsbUpiSelectorId(selector.number);

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.AnnaDsbUpiSelector
                            }
                        });
                    }
                });
            });
        }

        let lseSelectorsNumbers = selectorValidator.validate(config.lseSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'LSE', 'name', lse.type, config.type);
        if (lseSelectorsNumbers.length > 0) {

            lseSelectorsNumbers.forEach(number => {

                let selector = config.lseSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'LSE');

                errors.push({
                    content: `Invalid LSE '${name}'`, onClick: () => {

                        let htmlId = reportConfigNavigation.buildLSESelectorId(selector.number);

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.LseSelector
                            }
                        });
                    }
                });
            });
        }

        let symbolSelectorsNumbers = selectorValidator.validate(config.symbolSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'LSE', 'name', lse.type, config.type);
        if (symbolSelectorsNumbers.length > 0) {

            symbolSelectorsNumbers.forEach(number => {

                let selector = config.symbolSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'Symbol');

                let htmlId = reportConfigNavigation.buildSymbolSelectorId(selector.number);

                errors.push({
                    content: `Invalid Symbol '${name}'`, onClick: () => {

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.SymbolSelector
                            }
                        });
                    }
                });
            });
        }

        let fcaRegulatedEntitiesSelectorsNumbers = selectorValidator.validate(config.fcaRegulatedEntitiesSelectors, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections.dataSources, collections.reportFields, 'FCARegulatedEntities', 'name', lse.type, config.type);
        if (fcaRegulatedEntitiesSelectorsNumbers.length > 0) {

            fcaRegulatedEntitiesSelectorsNumbers.forEach(number => {

                let selector = config.fcaRegulatedEntitiesSelectors.find(a => a.number === number) as Selector;

                let name = selectorHelper.fallbackName(selector, 'FCARegulatedEntities');

                errors.push({
                    content: `Invalid FCA Regulated Entities '${name}'`, onClick: () => {

                        let htmlId = reportConfigNavigation.buildFCARegulatedEntitiesSelectorId(selector.number);

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: selector.number as number,
                                htmlId,
                                sectionId: htmlIds.cacheKeys,
                                componentType: ComponentType.FCARegulatedEntitiesSelector
                            }
                        });
                    }
                });
            });
        }

        if (config.type !== reportType.globalModule) {

            error = dictionaryValidator.validateDictionaries(config.dictionaries);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildDictionaryId(error.componentNumber as number);

                let number = error.componentNumber;

                errors.push({
                    content: error.message as string, onClick: () => {

                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number,
                                htmlId,
                                sectionId: htmlIds.dictionaries,
                                componentType: ComponentType.Dictionary
                            }
                        });
                    }
                });
            }

            error = dictionaryValidator.validateDictionaryFields(config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.dictionaries, collections.dataSources, config.type);
            if (error.message) {

                let dictionaryNumber = error.mainConmponentNumber;

                let fieldId = reportConfigNavigation.buildDictionaryFieldId(error.componentNumber as number);

                let dictId = reportConfigNavigation.buildDictionaryId(dictionaryNumber as number);

                errors.push({
                    content: error.message as string, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: dictionaryNumber,
                                htmlId: `${fieldId}-${dictId}`,
                                sectionId: htmlIds.dictionaries,
                                componentType: ComponentType.Dictionary
                            }
                        });
                    }
                });
            }

            error = filterValidator.validate(config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, config.variables, config.filters, collections.dataSources, collections.customDataSourceFields, collections.reportFields, config.type);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildFilterId(error.componentNumber as number);

                errors.push({ content: error.message, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.filters) });
            }

            error = endpointFilterValidator.validateByType(config.endpointFilters, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections, endpointFilterType.regular, [], config.type);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildEndpointFilterId(config.endpointFilters.find(f => f.number === error.componentNumber) as EndpointFilter);

                errors.push({ content: error.message, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.endpointFilters) });
            }

            error = endpointFilterValidator.validateByType(config.endpointFilters, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections, endpointFilterType.underReport, config.variables, config.type);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildUnderReportFilter(error.componentNumber as number);

                errors.push({ content: error.message, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.expectedUnderReport) });
            }

            error = endpointFilterValidator.validateByType(config.endpointFilters, config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, collections, endpointFilterType.overReport, [], config.type);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildOverReportFilter(error.componentNumber as number);

                errors.push({ content: error.message, onClick: () => reportConfigNavigation.navigateToItemInSection(htmlId, htmlIds.expectedOverReport) });
            }

            error = caseValidator.validate(config, collections.dataSources, collections.customDataSourceFields, collections.globalModuleConfig.userDefinedFunctions);
            if (error.message) {

                let htmlId = reportConfigNavigation.buildCaseId(error.componentNumber as number);

                let caseNumber = error.componentNumber;

                errors.push({
                    content: error.message, onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: caseNumber,
                                htmlId,
                                sectionId: htmlIds.cases,
                                componentType: ComponentType.Case
                            }
                        });
                    }
                });
            }

            let enrichmentErrors = enrichmentValidator.validate(config.userDefinedFunctions, collections.globalModuleConfig.userDefinedFunctions, config.lookups, config.dictionaries, config.variables, config.cases, collections.dataSources, collections.reportFields, collections.customDataSourceFields, config.type);

            enrichmentErrors.forEach(e => {

                let definition = reportFieldHelper.getById(collections.reportFields, e.fieldId);

                let caseNumber = e.caseNumber;

                let htmlId = reportConfigNavigation.buildReportFieldId(definition?.number as number);

                errors.push({

                    content: `Case ${caseNumber}, Field ${definition.name}`,

                    onClick: () => {
                        store.dispatch({
                            type: actions.navigation.navigatoToComponentNumber, payload: {
                                number: caseNumber,
                                htmlId,
                                sectionId: htmlIds.enrichment,
                                componentType: ComponentType.Case
                            }
                        });
                    }
                });
            });
        }

        let invalidValidation = accuracyValidationValidator.validate(config.validations, config.userDefinedFunctions, config.lookups, config.dictionaries, config.variables, collections.dataSources, collections.reportFields, collections.customDataSourceFields, config.regime, config.type);
        if (invalidValidation?.errors) {

            let htmlId = reportConfigNavigation.buildValidationId(invalidValidation.number, invalidValidation.kind);

            let validationKind = invalidValidation.kind === accuracyValidationKind.standard ? htmlIds.cnValidations : htmlIds.coreValidations;

            errors.push({
                content: 'Invalid validation(s)', onClick: () => {
                    reportConfigNavigation.navigateToSection(htmlIds.validations);
                    reportConfigNavigation.navigateToItemInSection(htmlId, validationKind);
                }
            });
        }

        let matchingKeyError = matchingKeyValidator.validate(config.matchingKey);
        if (matchingKeyError) {
            errors.push({ content: matchingKeyError, onClick: () => reportConfigNavigation.navigateToSection(htmlIds.matchingKeys) });
        }

        let matchingKeyEndpointError = matchingKeyValidator.validate(config.matchingKeyEndPoint);
        if (matchingKeyEndpointError) {
            errors.push({ content: matchingKeyEndpointError, onClick: () => reportConfigNavigation.navigateToSection(htmlIds.matchingKeys) });
        }
    }

    return errors;
};

export default validate;